import React, { useEffect } from "react";
import "./Added_To_Cart_Modal.css";
import { Modal } from "react-bootstrap";
import Blue_Btn from "../../common_btn/Blue_Btn/Blue_Btn";
import Black_Btn from "../../common_btn/Black_Btn/Black_Btn";
import { useNavigate } from "react-router-dom";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";

const Added_To_Cart_Modal = ({ onHide, handleViewDetails, ...props }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const cart = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    dispatch(getAllCart(isSignIn));
  }, [dispatch, props.show]);

  return (
    <section className="Added_To_Cart_Modal">
      <Modal
        {...props}
        size="md"
        backdrop={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-holder Added_To_Cart_Modal"
        scrollable={true}
        restoreFocus={false}
      >
        <Modal.Body>
          {cart?.data?.length > 0 ? (
            <div className="track_order_div">
              <div
                className="left_side_div"
                onClick={() => {
                  navigate(`/cart`);
                }}
              >
                <div className="img_holder">
                  <img
                    src={
                      process.env.REACT_APP_IMG_URL +
                      cart?.data?.[0]?.Product?.image
                    }
                    className="left_img"
                    alt="product"
                  />
                </div>

                <div className="text_holder">
                  <div className="title">
                    <p>{cart?.data?.[0]?.Product?.name}</p>
                  </div>
                  <div className="title">
                    <p>
                      {cart?.data?.[0]?.quantity} x ₹{" "}
                      {cart?.data?.[0]?.Triple_Variant?.price ||
                        cart?.data?.[0]?.Double_Variant?.price ||
                        cart?.data?.[0]?.Product_Variant?.price}
                    </p>
                  </div>
                  {cart?.data?.length > 1 && (
                    <div className="footer_text">
                      <p>and {cart?.data?.length - 1} more item</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="track_order_div">Cart is empty</div>
          )}

          <div className="close_div">
            <img
              src="/assets/images/icons/close.png"
              className="close_img"
              onClick={onHide}
            />
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Added_To_Cart_Modal;
